import React from "react";
import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const HeroContainer = styled.section`
  background: #000000;
  color: white;
  padding: 120px 20px 80px;
  text-align: center;
  position: relative;
  overflow: hidden;
  margin-top: 70px;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.3;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: linear-gradient(to top, rgba(220, 38, 38, 0.1), transparent);
  }
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
`;

const MainTitle = styled.h1`
  font-size: 4rem;
  font-weight: 800;
  margin-bottom: 24px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  animation: ${fadeInUp} 1s ease-out;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 2.8rem;
  }

  @media (max-width: 480px) {
    font-size: 2.2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.4rem;
  margin-bottom: 40px;
  animation: ${fadeInUp} 1s ease-out 0.2s both;
  font-weight: 300;
  opacity: 0.95;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const LoginOnlyMessage = styled.p`
  font-size: 1.1rem;
  animation: ${fadeInUp} 1s ease-out 0.4s both;
  font-weight: 500;
  background: rgba(220, 38, 38, 0.2);
  padding: 16px 32px;
  border-radius: 25px;
  display: inline-block;
  backdrop-filter: blur(10px);
  margin-bottom: 0;
  border: 1px solid rgba(220, 38, 38, 0.3);
`;

const HeroSectionSimple = () => {
  return (
    <HeroContainer>
      <HeroContent>
        <MainTitle>beatt pulse</MainTitle>
        <Subtitle>
          Plataforma beatt para Quick Checks Pulses
        </Subtitle>
        <LoginOnlyMessage>
          🔐 Acesso restrito • Apenas usuários cadastrados
        </LoginOnlyMessage>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSectionSimple;